import { render } from "./SearchResultItem.vue?vue&type=template&id=22ad9d52&scoped=true"
import script from "./SearchResultItem.vue?vue&type=script&lang=js"
export * from "./SearchResultItem.vue?vue&type=script&lang=js"

import "./SearchResultItem.vue?vue&type=style&index=0&id=22ad9d52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ad9d52"]])

export default __exports__